import jsPDF from 'jspdf';
const MARGIN_TOP = 5;
const MARGIN_DOWN = 5;
const MARGIN_RIGHT = 5;
const MARGIN_LEFT = 15;

function setWidthAndHeight(p_properties, p_header) {
    let widthPage;
    let heightPage;
    if (p_properties.pageSize == 'letter') {
        widthPage = 216;
        heightPage = 279;
    } else if (p_properties.pageSize == 'legal') {
        widthPage = 216;
        heightPage = 356;
    } else if (p_properties.pageSize == 'a3') {
        widthPage = 297;
        heightPage = 420;
    } else if (p_properties.pageSize == 'a5') {
        widthPage = 148;
        heightPage = 210;
    } else { //'a4'
        widthPage = 210;
        heightPage = 297;
    } 
    if (p_properties.pageOrientation == 'portrait') {
        p_properties.width = widthPage;
        p_properties.height = heightPage;    
    } else {  // landscape
        p_properties.width = heightPage;
        p_properties.height = widthPage;    
    }
    p_properties.halfWidth = Math.round(p_properties.width / 2, 0); 
    p_properties.page = 1;
}

function setWidthFormData(p_properties, p_header) {
    if (p_header.dataTitle && (p_header.dataTitle.length > 0)) {
        let widthwidthoutMargin = p_properties.width - MARGIN_RIGHT - MARGIN_LEFT;
        let average = widthwidthoutMargin / p_header.dataTitle.length;
        for (var index = 0; index < p_header.dataTitle.length; index++) {
            let newWidth = average; 
            if (p_header.dataTitle[index].widthTitle) {
                newWidth = Math.round(widthwidthoutMargin * (p_header.dataTitle[index].widthTitle / 100), 0);
            }
            p_header.dataTitle[index].widthTitle = newWidth;
            newWidth = average; 
            if (p_header.dataTitle[index].widthField) {
                newWidth = Math.round(widthwidthoutMargin * (p_header.dataTitle[index].widthField / 100), 0);
            }
            p_header.dataTitle[index].widthField = newWidth;
        }    
    }
}

function setWidthListData(p_properties, p_header) {
    if (p_header.dataTitle && (p_header.dataTitle.length > 0)) {
        let widthwidthoutMargin = p_properties.width - MARGIN_RIGHT - MARGIN_LEFT;
        let average = widthwidthoutMargin / p_header.dataTitle.length;
        for (var index = 0; index < p_header.dataTitle.length; index++) {
            let newWidth = average; 
            if (p_header.dataTitle[index].width) {
                newWidth = Math.round(widthwidthoutMargin * (p_header.dataTitle[index].width / 100), 0);
            }
            p_header.dataTitle[index].width = newWidth;
        }    
    }
}

function textFormat(p_text, p_type) {
    let text = '';   
    if (p_text && p_type == 'I'){
        text = p_text.toString();
    } else if (p_text) {
        text = p_text;
    }
    return text;
}

function printCell(p_pdf, p_properties, p_header, p_index, p_text) {
    let alignment = 'left';
    let colAdd = 0;
    if (p_header.dataTitle[p_index].alignment == 'right' ){
        alignment = 'right';
        colAdd = p_header.dataTitle[p_index].width;  
    } else if (p_header.dataTitle[p_index].alignment == 'center' ){
        colAdd = Math.round(p_header.dataTitle[p_index].width / 2, 0);
        alignment = 'center';
    }    
    let type = p_header.dataTitle[p_index].type;
    let text = textFormat(p_text, type);   
    p_pdf.text(text, (p_properties.col + colAdd), p_properties.fila, alignment);
}

function printHeader(p_pdf, p_properties, p_header, p_isList) {
    p_properties.fila = MARGIN_TOP + 7;
    if (p_header.logo) {
        p_pdf.addImage(p_header.logo, "PNG", MARGIN_LEFT, MARGIN_TOP, 20, 20);
    }
    p_pdf.setFont("helvetica", "bolditalic");
    p_pdf.setFontSize(12);
    p_pdf.text(p_header.agencia, 37, p_properties.fila, 'left' );
    p_properties.fila += 4;
    p_pdf.setFont("helvetica", "normal");
    p_pdf.setFontSize(8);
    p_pdf.text(p_header.notaAgencia, 37, p_properties.fila, 'left' );
    p_properties.fila += 3;
    p_pdf.setFont("helvetica", "bolditalic");
    p_pdf.setFontSize(12);
    p_pdf.text(p_header.title, p_properties.halfWidth, p_properties.fila, 'center' );
    p_properties.fila += 4;
    if (p_header.subTitle) {
        p_pdf.setFont("helvetica", "normal");
        p_pdf.setFontSize(10);
        p_pdf.text(p_header.subTitle, p_properties.halfWidth, p_properties.fila, 'center' );
    }
    p_properties.fila += 2;    
    if (p_isList && p_header.dataTitle && (p_header.dataTitle.length > 0)) {
        p_pdf.setFont("arial", "bold");
        p_pdf.setFontSize(8);    
        p_properties.col = MARGIN_LEFT;
        p_pdf.setFillColor(244, 245, 245);
        p_pdf.rect(MARGIN_LEFT, p_properties.fila, p_properties.width - MARGIN_RIGHT - MARGIN_LEFT, 5, "F");
        p_pdf.setLineWidth(0.1);
        p_pdf.line(MARGIN_LEFT, p_properties.fila, p_properties.width - MARGIN_RIGHT, p_properties.fila);
        p_properties.fila += 3;    
        for (var index = 0; index < p_header.dataTitle.length; index++) {
            printCell(p_pdf, p_properties, p_header, index, p_header.dataTitle[index].title);
            p_properties.col += p_header.dataTitle[index].width;
        }
        p_properties.fila += 2;    
    }
    p_pdf.line(MARGIN_LEFT, p_properties.fila, p_properties.width - MARGIN_RIGHT, p_properties.fila);
    p_properties.fila += 4;
}

function printFooter(p_pdf, p_properties) {
    p_properties.fila = p_properties.height - MARGIN_DOWN - 8;
    p_pdf.setLineWidth(0.1);
    p_pdf.line(MARGIN_LEFT, p_properties.fila, p_properties.width - MARGIN_RIGHT, p_properties.fila);
    p_properties.fila += 4;
    p_pdf.setFont("helvetica", "normal");
    p_pdf.setFontSize(12);
    p_pdf.text(p_properties.page.toString(), p_properties.halfWidth, p_properties.fila, 'center' );
}

function addPage(p_pdf, p_properties) {
    p_properties.page += 1;
    p_pdf.addPage();
}

function getListValue(p_id, p_listValues) {
    let value = "";
    let index = 0;
    while (index < p_listValues.length && value == "") {
        if (p_listValues[index].value == p_id){
            value = p_listValues[index].text;
        }
        index++
    }
    return value;
}

function printDataList(p_pdf, p_properties, p_header, p_data) {
    if (p_data && (p_data.length > 0)) {
        let isPrintHeader = true;
        for (var record = 0; record < p_data.length; record++) {
            if (isPrintHeader) {
                isPrintHeader = false;
                printHeader(p_pdf, p_properties, p_header, true);
                p_pdf.setFont("arial", "normal");
                p_pdf.setFontSize(8);
            } 
            p_properties.col = MARGIN_LEFT;
            for (var index = 0; index < p_header.dataTitle.length; index++) {
                let textValue = p_data[record][p_header.dataTitle[index].field];
                if (p_header.dataTitle[index].listValues){
                    textValue = p_header.dataTitle[index].listValues[textValue].text;
                    //textValue = getListValue(textValue, p_header.dataTitle[index].listValues);
                }
                printCell(p_pdf, p_properties, p_header, index, textValue);
                p_properties.col += p_header.dataTitle[index].width;
            }
            p_properties.fila += 4;
        } 
        if (!isPrintHeader) {
            printFooter(p_pdf, p_properties);
        }   
    }
}

function printDataForm(p_pdf, p_properties, p_header, p_data) {
    if (p_data && (p_data.length > 0)) {
        let isPrintHeader = true;
        for (var record = 0; record < p_header.dataTitle.length; record++) {    
            if (isPrintHeader) {
                isPrintHeader = false;
                printHeader(p_pdf, p_properties, p_header, false);
                p_pdf.setFontSize(10);
                p_properties.fila += 4;
            } 
            let fieds = p_header.dataTitle[record].fields;
            let titles = p_header.dataTitle[record].titles;
            let types = p_header.dataTitle[record].types;
            p_properties.col = MARGIN_LEFT;
            for (var index = 0; index < fieds.length; index++) {
                p_pdf.setFont("arial", "bold");
                let textTitle = titles[index]  + ': ';
                p_properties.col += p_header.dataTitle[record].widthTitle; 
                p_pdf.text(textTitle, p_properties.col, p_properties.fila, 'right');
                p_pdf.setFont("arial", "normal");
                let text = textFormat(p_data[0][fieds[index]], types[index]);
                p_pdf.text(text, p_properties.col, p_properties.fila, 'left');
                p_properties.col += p_header.dataTitle[record].widthField;
            }
            p_properties.fila += 6;
        } 
        if (!isPrintHeader) {
            printFooter(p_pdf, p_properties);
        }   
    }
}

export function printDataToPdf(p_properties, p_header, p_data) {
    let pdf = new jsPDF(p_properties.pageOrientation, 'mm', p_properties.pageSize);
    pdf.setProperties({
        title: p_header.title,
        author: p_header.agencia,
        creator: p_header.agencia
    });
    setWidthAndHeight(p_properties, p_header);
    if (p_properties.format == 'list') {
        setWidthListData(p_properties, p_header);
        printDataList(pdf, p_properties, p_header, p_data);
    } else if (p_properties.format == 'form') {
        setWidthFormData(p_properties, p_header);
        printDataForm(pdf, p_properties, p_header, p_data);
    }    
    let fileName = p_header.title + p_properties.fileName;
    pdf.save(fileName);
}



// WEBPACK FOOTER //
// ./src/assets/js/printPdf.js